// @flow
import { crudController } from 'fc-controller'

import { URL, MODEL, TREE, BRANCH } from 'hfty-model-orders'

// Selectors
import token$ from 'fc-auth/src/selectors/token'
import composeFetchSaga from 'fc-fetch-worker/src/sagas/composeFetchSaga'
import worker from 'hfty-wrkr-orders'

// Controller
export default crudController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  initialize: function initialize (controller: Object): Promise<Object> {
    const terminate = function terminate () {
      if (worker) {
        worker.terminate()
      }
    }

    return new Promise((resolve: Function) => {
      terminate()

      resolve({
        terminate,
        handleFetch: composeFetchSaga({
          getWorker: function (): Worker {
            return worker.getWorker()
          },
        }),
      })
    })
  },
})
